import { ConfirmationService } from './services/confirmation.service';
import { TranslateService } from '@ngx-translate/core';
import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SeoService } from './services/seo.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  readonly confirmation = inject(ConfirmationService);
  private readonly translate = inject(TranslateService);
  title = 'Basilethiry.fr';
  showBottomNav = false;

  private readonly destroyRef = inject(DestroyRef);

  /** Initialise le titre et garde la barre du bas synchronisée avec la route active. */
  constructor(private router: Router, private titleService: Title, private readonly seo: SeoService) {
    this.titleService.setTitle(this.title);
    this.translate.onLangChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.updateTitle(this.router.url));
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects.split(/[?#]/)[0];
        this.updateTitle(url);
        this.showBottomNav = [
          '/about',
          '/portfolio',
          '/school-career',
          '/contact',
        ].includes(url);
      });
  }

  private updateTitle(url: string): void {
    const path = url.split(/[?#]/)[0];
    const keys: Record<string, string> = { '/':'HOME', '/login':'LOGIN_TITLE', '/register':'REGISTER_TITLE',
      '/forgot-password':'FORGOT_PASSWORD_TITLE', '/reset-password':'RESET_PASSWORD_TITLE',
      '/notifications':'NOTIFY_TITLE', '/profile':'PROFILE_TITLE', '/about':'ABOUT_TITLE', '/portfolio':'PORTFOLIO_TITLE',
      '/school-career':'SCHOOL_CAREER_TITLE', '/contact':'CONTACT_TITLE', '/qr-generator':'NAV_QR',
      '/mes-qr-codes':'MY_QR_CODES_TITLE', '/add-torrent':'NAV_MEDIA', '/youtube-download':'NAV_YOUTUBE',
      '/media-convert':'NAV_CONVERT', '/image-convert':'NAV_IMAGE_CONVERT', '/torrent-doc':'DOC_MEDIA_TITLE', '/pixel-game':'PIXEL_GAME_TITLE',
      '/admin/users':'NAV_USERS', '/admin/media-links':'NAV_MEDIA_LINKS', '/admin/torrents':'ADMIN_TORRENTS_TITLE',
      '/noel':'NAV_NOEL', '/budget':'NAV_BUDGET', '/admin/budget':'NAV_BUDGET', '/legal':'LEGAL_LINK', '/access-denied':'UI_ACCESS_DENIED' };
    const key = /^\/qrcode\/[^/]+\/?$/.test(path) ? 'QR_REDIRECT_TITLE' : keys[path] ?? 'UI_NOT_FOUND';
    this.seo.update(path, key);
  }

}
